// extracted by mini-css-extract-plugin
export default {"container":"s0-z","heading":"t0-z","links":"u0-z","copy":"v0-z","subCopy":"w0-z","linksLeft":"x0-z","linksCenter":"y0-z","linksRight":"z0-z","link":"A0-z","onlyLink":"B0-z"};